export const pageDefaultPageNumber = 1
export const pageDefaultPageSize = 10
export const pageDefaultTotal = 0
